/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Branche à laquelle un indice est rattaché.
 * @export
 * @interface IndiceBrancheDto
 */
export interface IndiceBrancheDto {
    /**
     * 
     * @type {string}
     * @memberof IndiceBrancheDto
     */
    branchId?: string;
    /**
     * 
     * @type {string}
     * @memberof IndiceBrancheDto
     */
    branchCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndiceBrancheDto
     */
    branchLabel?: string | null;
}

/**
 * Check if a given object implements the IndiceBrancheDto interface.
 */
export function instanceOfIndiceBrancheDto(value: object): value is IndiceBrancheDto {
    return true;
}

export function IndiceBrancheDtoFromJSON(json: any): IndiceBrancheDto {
    return IndiceBrancheDtoFromJSONTyped(json, false);
}

export function IndiceBrancheDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndiceBrancheDto {
    if (json == null) {
        return json;
    }
    return {
        
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'branchLabel': json['branchLabel'] == null ? undefined : json['branchLabel'],
    };
}

export function IndiceBrancheDtoToJSON(json: any): IndiceBrancheDto {
    return IndiceBrancheDtoToJSONTyped(json, false);
}

export function IndiceBrancheDtoToJSONTyped(value?: IndiceBrancheDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchId': value['branchId'],
        'branchCode': value['branchCode'],
        'branchLabel': value['branchLabel'],
    };
}

